import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

// Password field with a show/hide eye toggle. Forwards all Input props.
export const PasswordInput = React.forwardRef(({ className = "", ...props }, ref) => {
  const [show, setShow] = useState(false);
  const testId = props["data-testid"];
  return (
    <div className="relative">
      <Input ref={ref} type={show ? "text" : "password"} className={`pr-10 ${className}`} {...props} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-md transition-colors"
        style={{ color: "var(--yalola-text-muted)" }}
        tabIndex={-1}
        aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
